module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "w-100"
  }, [_c('thead', [_c('tr', {
    staticClass: "headers"
  }, _vm._l((_vm.columns), function(col, indexCol) {
    return _c('th', {
      key: indexCol
    }, [_vm._v(_vm._s(col.title))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.rowsComputed), function(row, indexRow) {
    return _c('tr', {
      key: indexRow
    }, [_vm._t("default", null, {
      row: row
    })], 2)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16994cd8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tableStd.vue
// module id = 663
// module chunks = 10 13